import { gql } from 'apollo-angular';
import { Invoice } from '../../shared/entities/payment/payment';

export const INVOICES_QUERY = gql`
query getInvoices(
  $tenantId: String
)
{
  invoices: getInvoices(
    tenantId: $tenantId
  )
  {
    number
    date
    amount
    currency
    downloadLink
    state
  }
}
`;

export interface InvoicesQueryResponse {
  loading: boolean;
  invoices: Invoice[];
}

